import { render, staticRenderFns } from "./ColorSwatches.vue?vue&type=template&id=434d6a75&scoped=true&"
import script from "./ColorSwatches.vue?vue&type=script&lang=js&"
export * from "./ColorSwatches.vue?vue&type=script&lang=js&"
import style0 from "./ColorSwatches.vue?vue&type=style&index=0&id=434d6a75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434d6a75",
  null
  
)

export default component.exports